export default __webpack_public_path__ + "static/media/profilePic2.f7274c5a.jpg";